var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_imp@2/3471/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/_cof.js
// module id = 20
// module chunks = 0